import React from 'react';
import Section from '../Section';
import TitledContent from '../TitledContent';
import masks from '../../utils/masks';

const ConfirmContactData = ({
  clientCellphone,
  clientResidencePhone,
  clientComercialPhone,
  clientEmail,
  clientInformationType,
}) => (
  <Section displayGrid title="Contato">
    <TitledContent
      marginBottom
      title="Telefone Celular"
      content={masks.phone.mask(clientCellphone)}
    />

    <TitledContent
      marginBottom
      title="Telefone Residencial"
      content={masks.homePhone.mask(clientResidencePhone)}
    />

    <TitledContent
      marginBottom
      title="Telefone Comercial"
      content={masks.commercialPhone.mask(clientComercialPhone)}
    />
    <TitledContent
      marginBottom
      wordBreakAll
      title="Email"
      content={clientEmail}
    />

    <TitledContent
      marginBottom
      title="Recebimento de informações"
      content={clientInformationType}
    />
  </Section>
);

export default ConfirmContactData;
